<template>
<div>
    <div class="error_popup popup-desktop" v-if="submitting" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Please wait...</div>
            <div class="text-block-1102">Submitting medical form!</div>
        </div>
    </div>
    <div class="error_popup popup-desktop" v-if="errorOccurred" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">An Error Occurred while submitted form.</div>
            <div class="text-block-1102">While we get current offer details!</div>
            <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="errorOccurred=false">Close</a>
        </div>
    </div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/NewSelf_Logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>3</strong> of <strong>3</strong> Pre-Qualify
                            </div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((currentQuestionIndex) / totalQuestions) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="section-7">
        <div class="questions-div">
            <div class="question-content">
                <div class="question-container" v-if="currentQuestion">
                    <div class="question-div-2">
                        <div class="text-block-513" v-if="currentQuestion.question_type === 'consent'">{{ currentQuestion.header }}</div>
                        <div class="text-block-513" v-else>{{ currentQuestion.label }}</div>
                        <div class="form-subs" v-if="currentQuestion.sublabel" v-html="currentQuestion.sublabel"></div>
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'radio'">
                            <div class="div-block-1487">
                                <a href="#" v-for="option in currentQuestion.options_array" :key="option" @click.prevent="selectAnswer(option)" class="button-68 w-button">{{option}}</a>
                            </div>
                        </div>

                        <div v-if="currentQuestion.question_type === 'consent'">
                            <div class="consent-text" v-html="currentQuestion.consent_text"></div>
                            <div class="felix-form-block w-form">
                                <div v-for="option in currentQuestion.options_array" :key="option" @click.prevent="selectAnswer(option)">
                                    <a href="#" class="link-block-30 w-inline-block acceptbutton"  v-if="isAreeeButton(option)">
                                        <div>
                                            <div class="text-block-545">{{option}}</div>
                                        </div>
                                    </a>
                                </div>
                                <div v-for="option in currentQuestion.options_array" :key="option" @click.prevent="selectAnswer(option)">
                                    <a href="#" class="link-block-30 w-inline-block rejectconbutton"  v-if="isNotAreeeButton(option)">
                                        <div>
                                            <div class="text-block-545">{{option}}</div>
                                        </div>
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'height_weight'">
                            <div class="div-block-1478 mobile-entry form _2 height top">
                                <input class="text-field-44 height w-input" maxlength="256" :value="height.feet" @input="handleHeightInput($event, 'feet')" placeholder="Feet" type="text" required>
                                <input class="text-field-44 height w-input" maxlength="256" :value="height.inches" @input="handleHeightInput($event, 'inches')" placeholder="Inches" type="text" required>
                            </div>
                            <div class="div-block-1479 mobile-entry form _2 weight">
                                <input class="text-field-45 weight w-input" maxlength="256" :value="weight" @input="handleWeightInput" placeholder="Weight in pounds" type="text" required>
                            </div>
                            <div v-if="bmi" class="bmi-result">
                                Your BMI: {{ bmi.toFixed(1) }}
                            </div>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'checkbox'">
                            <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentQuestion.options_array" :key="option">
                                <input type="checkbox" :value="option" v-model="checkboxAnswers[currentQuestion.question]" @change="handleCheckboxChange($event, option)" class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{option}}</span>
                            </label>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'textarea'">
                            <div class="condition-question mb-4">
                                <textarea v-model="answers[currentQuestion.question]" placeholder="Enter your answer here" class="textarea w-input" rows="3" required></textarea>
                            </div>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'radio_more'">
                            <form>
                                <a href="#" class="link-block-30 w-inline-block" v-for="option in currentQuestion.options_array" :key="option" @click.prevent="selectAnswer(option)">
                                    <div>
                                        <div class="text-block-545">{{option}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_choice'">
                            <div class="div-block-1487">
                                <a href="#" v-for="option in currentQuestion.options_array" :key="option" @click.prevent="checkImageChoice(option)" class="button-68 w-button">{{option}}</a>
                            </div>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_upload'">
                            <ImageUploader image-type="prescription_image" :question-id="parseInt(currentQuestion.id)" @image-uploaded="handleImageUploaded" />
                        </div>

                    </div>
                </div>
                <!-- Navigation -->
                <button type="submit" class="form-button w-button balugabtn" v-if="!['radio', 'image_choice','radio_more','consent','image_upload'].includes(currentQuestion.question_type)" @click="nextQuestion" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed"> Next -> </button>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import questionsConfig from '@/utils/balugaWLQuestions.json'
import ImageUploader from "../common/imageUploadBox.vue"
export default {
    name: 'WeightLossQuestionnaire',
    components: {
        ImageUploader,
      
    },
    props:{
        initialData: {
        type: Object,
        default: () => ({})
        },
    },
    data() {
        return {
            errorOccurred: false,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            currentQuestionIndex: 0,
            submitting: false,
            answers: {},
            checkboxAnswers: {},
            height: {
                feet: '',
                inches: ''
            },
            weight: '',
            imagePreview: null,
            questions: questionsConfig.questions,
            dependencies: questionsConfig.dependency,
            skippedQuestions: [] 
        }
    },

    computed: {
        totalQuestions() {
            return this.questions.length
        },

        currentQuestion() {
            return this.questions[this.currentQuestionIndex]
        },

        bmi() {
            if (this.height.feet && this.height.inches && this.weight) {
                const heightInInches = (parseInt(this.height.feet) * 12) + parseInt(this.height.inches)
                return (parseInt(this.weight) * 703) / (heightInInches * heightInInches)
            }
            return null
        },

        canProceed() {
            if (!this.currentQuestion) return false

            const questionId = this.currentQuestion.question

            switch (this.currentQuestion.question_type) {
                case 'radio':
                case 'image_choice':
                case 'consent':
                    return !!this.answers[questionId]

                case 'checkbox': {
                    const selectedOptions = this.checkboxAnswers[questionId] || []
                    return selectedOptions.length > 0
                }

                case 'textarea':
                    return !!this.answers[questionId]?.trim()

                case 'height_weight':
                    return this.isHeightWeightValid

                case 'image_upload':
                    if (this.currentQuestion.options_array?.length) {
                        return !!this.answers[questionId]
                    }
                    return !!this.imagePreview

                default:
                    return true
            }
        },

        isHeightWeightValid() {
            const feet = parseInt(this.height.feet)
            const inches = parseInt(this.height.inches)
            const weight = parseInt(this.weight)

            return feet >= 4 && feet <= 8 && // Reasonable height range
                inches >= 0 && inches <= 11 && // Valid inches
                weight >= 50 && weight <= 1000 // Reasonable weight range
        }
    },

    methods: {
        isAreeeButton(value){
            var text = ["I acknowledge that I have read and understood the above information", "I acknowledge that I have read and understood the above information","I acknowledge that I have read and understood the above information", "I acknowledge that I have read and understood the above information","I acknowledge that I have read and understood the above information"]
            return text.includes(value)
        },
        isNotAreeeButton(value){
            var text = ["I acknowledge that I have read and understood the above information", "I acknowledge that I have read and understood the above information","I acknowledge that I have read and understood the above information", "I acknowledge that I have read and understood the above information","I acknowledge that I have read and understood the above information"]
            return !text.includes(value)
        },
        checkDisqualification(answer) {
            const question = this.currentQuestion;
            if (!question.disqualify_on) return false;

            let isDisqualified = false;

            if (question.question_type === 'checkbox' && Array.isArray(answer)) {
                // For checkbox, check if any selected option is in the disqualify_on array
                isDisqualified = answer.some(selected =>
                    question.disqualify_on.includes(selected)
                );
            } else {
                // For radio and consent, check if the answer is in disqualify_on array
                isDisqualified = question.disqualify_on.includes(answer);
            }

            if (isDisqualified) {
                this.handleDisqualification(question.disqualify_message || 'Based on your responses, we cannot proceed with your application.');
                return true;
            }

            return false;
        },
        handleDisqualification(message) {
            this.$router.push({
                name: 'leadDisqualified',
                query: {
                    message,
                    questionId: this.currentQuestion.id
                }
            });
        },
        handleImageUploaded(data) {
            console.log("moving to next ")
            this.answers[this.currentQuestion.question] = data.base64;
            this.proceedToNext();
        },
        handleCheckboxChange(event, option) {
    const questionId = this.currentQuestion.question;

    if (!this.checkboxAnswers[questionId]) {
        this.$set(this.checkboxAnswers, questionId, []);
    }

    if (event.target.checked) {
        this.checkboxAnswers[questionId].push(option);
        
        // Handle follow-up questions
        if (this.currentQuestion.followup_questions?.[option]) {
            this.addFollowUpQuestion(this.currentQuestion.followup_questions[option]);
        }

        // Explicitly check for Gallbladder disease
        if (option === 'Gallbladder disease' && this.currentQuestion.id === '6') {
            const gallbladderConsent = this.questions.find(q => q.id === '7');
            if (gallbladderConsent) {
                const insertIndex = this.currentQuestionIndex + 1;
                this.questions.splice(insertIndex, 0, gallbladderConsent);
            }
        }
    } else {
        const index = this.checkboxAnswers[questionId].indexOf(option);
        if (index > -1) {
            this.checkboxAnswers[questionId].splice(index, 1);
            
            if (this.currentQuestion.followup_questions?.[option]) {
                this.removeFollowUpQuestion(this.currentQuestion.followup_questions[option].id);
            }

            // Remove gallbladder consent if unchecked
            if (option === 'Gallbladder disease') {
                const consentIndex = this.questions.findIndex(q => q.id === '7');
                if (consentIndex > -1) {
                    this.questions.splice(consentIndex, 1);
                }
            }
        }
    }

    // Moved after question manipulations
    this.evaluateDependencies();
    this.checkDisqualification(this.checkboxAnswers[questionId]);
},
        evaluateDependencies() {
            // Find all dependencies that depend on the current question
            const currentId = this.currentQuestion.id;
            const relevantDependencies = this.dependencies.filter(d => 
                d.dependent_on === currentId || 
                (Array.isArray(d.dependent_on) && d.dependent_on.includes(currentId))
            );

            // Debug log
            console.log("Relevant dependencies:", relevantDependencies);

            // For each relevant dependency, check if its question should be shown
            relevantDependencies.forEach(dependency => {
                // Debug log
                console.log("Checking dependency:", dependency);
                
                const shouldShow = this.checkDependency(dependency);
                console.log("Should show dependency:", shouldShow);

                const dependentQuestion = this.questions.find(q => q.id === dependency.question_id);
                
                if (shouldShow && dependentQuestion) {
                    // Check if question is already in the list
                    const existingIndex = this.questions.findIndex(q => q.id === dependency.question_id);
                    if (existingIndex === -1) {
                        // Debug log
                        console.log("Adding dependent question:", dependentQuestion);
                        
                        const insertIndex = this.findAppropriateInsertIndex(dependency.question_id);
                        this.questions.splice(insertIndex, 0, dependentQuestion);
                    }
                }
            });
        },
        findAppropriateInsertIndex(questionId) {
            if (questionId === "7") {
                // For gallbladder consent, insert after question 6 and its follow-ups
                const baseIndex = this.questions.findIndex(q => q.id === "6");
                if (baseIndex === -1) return this.questions.length;
                
                // Find the last follow-up question for question 6
                let lastFollowUpIndex = baseIndex;
                for (let i = baseIndex + 1; i < this.questions.length; i++) {
                    if (this.questions[i].id.startsWith("6_")) {
                        lastFollowUpIndex = i;
                    } else {
                        break;
                    }
                }
                return lastFollowUpIndex + 1;
            }
            
            // Regular handling for other questions
            const currentIndex = this.questions.findIndex(q => q.id === this.currentQuestion.id);
            return currentIndex + 1;
        },
        addFollowUpQuestion(followUpQuestion) {
            // Find the current question's index
            const currentIndex = this.questions.findIndex(q => q.id === this.currentQuestion.id);
            
            // Find the last follow-up question for the current question
            let lastFollowUpIndex = currentIndex;
            const currentQuestionPrefix = this.currentQuestion.id + '_';
            
            for (let i = currentIndex + 1; i < this.questions.length; i++) {
                if (this.questions[i].id.startsWith(currentQuestionPrefix)) {
                lastFollowUpIndex = i;
                } else {
                break;
                }
            }
            
            // Only add if the question doesn't already exist
            if (!this.questions.find(q => q.id === followUpQuestion.id)) {
                // Insert after the last follow-up question
                this.questions.splice(lastFollowUpIndex + 1, 0, followUpQuestion);
            }
        },

        // New method to remove all follow-up questions for a given question ID
        removeFollowUpQuestions(questionId) {
            // Get the base question
            const baseQuestion = this.questions.find(q => q.id === questionId);
            if (!baseQuestion?.followup_questions) return;

            // Recursively get all follow-up question IDs
            const followUpIds = this.getAllFollowUpIds(baseQuestion);
            
            // Remove all follow-up questions and their answers
            this.questions = this.questions.filter(q => !followUpIds.includes(q.id));
            followUpIds.forEach(id => {
            const question = this.questions.find(q => q.id === id);
            if (question) {
                delete this.answers[question.question];
            }
            });
        },
        getAllFollowUpIds(question) {
            let ids = [];
            if (question.followup_questions) {
            Object.values(question.followup_questions).forEach(followUp => {
                ids.push(followUp.id);
                // Recursively get nested follow-up IDs
                ids = ids.concat(this.getAllFollowUpIds(followUp));
            });
            }
            return ids;
        },
        isOptionSelected(option) {
            const questionId = this.currentQuestion.question
            return this.checkboxAnswers[questionId]?.includes(option) || false
        },

        validateAndUpdateHeightWeight() {
            const feet = parseInt(this.height.feet)
            const inches = parseInt(this.height.inches)

            if (inches >= 12) {
                this.height.feet = (feet + Math.floor(inches / 12)).toString()
                this.height.inches = (inches % 12).toString()
            }
        },

        handleHeightInput(event, field) {
            const value = event.target.value
            if (field === 'feet') {
                this.height.feet = value
            } else {
                this.height.inches = value
            }
            this.validateAndUpdateHeightWeight()
        },

        handleWeightInput(event) {
            const value = event.target.value
            if (value) {
                this.weight = parseInt(value).toString()
            } else {
                this.weight = ''
            }
        },

        selectAnswer(option) {
            const currentQuestion = this.currentQuestion;
            this.answers[currentQuestion.question] = option;
            
            // Remove any existing follow-up questions and their subsequent questions
            this.removeFollowUpQuestions(currentQuestion.id);
            
            if (option !== "None of these" && option !== "None of the above") {
                // Add new follow-up questions if they exist
                if (currentQuestion.followup_questions?.[option]) {
                this.addFollowUpQuestion(currentQuestion.followup_questions[option]);
                }

                // If there are dependencies for this question's follow-ups
                const followUpDependencies = this.dependencies.filter(d => 
                d.dependent_on === currentQuestion.id && 
                d.ask_if_val_in.includes(option)
                );

                // Add dependent questions if they exist
                if (followUpDependencies.length > 0) {
                followUpDependencies.forEach(dep => {
                    const nextQuestion = this.questions.find(q => q.id === dep.question_id);
                    if (nextQuestion) {
                    this.addFollowUpQuestion(nextQuestion);
                    }
                });
                }
            }

            // Check for disqualification before proceeding
            if (!this.checkDisqualification(option)) {
                this.nextQuestion();
            }
        },
        checkImageChoice(option) {
            this.answers[this.currentQuestion.question] = option
            if (option === 'Yes') {
                this.nextQuestion()
            } else {
                this.proceedToNext()
            }
        },
        getImageForOption(option) {
            const imageMap = {
                'Female': '/images/female-icon.svg',
                'Male': '/images/male-icon.svg'
            }
            return imageMap[option] || ''
        },

        async handleImageUpload(event) {
            const file = event.target.files[0]
            if (!file) return

            const reader = new FileReader()
            reader.onload = (e) => {
                this.imagePreview = e.target.result
                this.answers[this.currentQuestion.question] = e.target.result
            }
            reader.readAsDataURL(file)
        },
        previousQuestion() {
            if (this.currentQuestionIndex > 0) {
                this.currentQuestionIndex--
            }
        },

        nextQuestion() {
            if (this.currentQuestion.question_type === 'radio' ||
                this.currentQuestion.question_type === 'image_choice') {
                if (this.answers[this.currentQuestion.question]) {
                    this.proceedToNext()
                }
                return
            }

            if (this.canProceed) {
                this.proceedToNext()
            }
        },
        proceedToNext() {
            // Handle height/weight special case
            if (this.currentQuestion.question_type === 'height_weight') {
                this.answers.height = this.height;
                this.answers.weight = this.weight;
                this.answers.bmi = this.bmi;
            }

            // Get current answer based on question type
            const answer = this.currentQuestion.question_type === 'checkbox' 
                ? this.checkboxAnswers[this.currentQuestion.question]
                : this.answers[this.currentQuestion.question];

            // Check for disqualification before proceeding
            if (this.checkDisqualification(answer)) {
                return;
            }

            let nextIndex = this.currentQuestionIndex + 1;

            // Special handling for Gallbladder disease
            if (this.currentQuestion.id === '6' && 
                this.checkboxAnswers[this.currentQuestion.question]?.includes('Gallbladder disease')) {
                // Find the gallbladder consent question
                const gallbladderConsentIndex = this.questions.findIndex(q => q.id === '7');
                if (gallbladderConsentIndex === -1) {
                    // If consent question isn't in the list, add it
                    const gallbladderConsent = questionsConfig.questions.find(q => q.id === '7');
                    if (gallbladderConsent) {
                        this.questions.splice(nextIndex, 0, gallbladderConsent);
                    }
                }
            }

            // If we've reached the end, submit the questionnaire
            if (nextIndex >= this.questions.length) {
                this.submitQuestionnaire();
                return;
            }

            // Rest of the existing proceedToNext logic
            while (nextIndex < this.questions.length) {
                const nextQuestion = this.questions[nextIndex];

                // Skip questions that already have answers from initialization
                if (this.skippedQuestions.includes(nextQuestion.id)) {
                    nextIndex++;
                    continue;
                }
                
                const dependency = this.dependencies.find(d => d.question_id === nextQuestion.id);
            
                // If no dependency, show the question
                if (!dependency) {
                    break;
                }

                // Handle case where dependent_on is an array
                const dependentOn = Array.isArray(dependency.dependent_on) 
                    ? dependency.dependent_on 
                    : [dependency.dependent_on];

                let shouldShowQuestion = false;

                // Check all parent questions
                for (const parentId of dependentOn) {
                    const parentQuestion = this.questions.find(q => q.id === parentId);
                    
                    if (!parentQuestion) {
                        console.warn(`Parent question ${parentId} not found`);
                        continue;
                    }

                    // Get parent answer, including pre-filled answers
                    const parentAnswer = parentQuestion.question_type === 'checkbox'
                        ? this.checkboxAnswers[parentQuestion.question]
                        : (this.answers[parentQuestion.question] || this.getPrefilledAnswer(parentQuestion.id));

                    // Handle different types of dependencies
                    if (dependency.ask_if_val_includes && Array.isArray(parentAnswer)) {
                        shouldShowQuestion = parentAnswer.some(ans => 
                            dependency.ask_if_val_includes.includes(ans)
                        );
                    } else if (dependency.ask_if_val_in) {
                        shouldShowQuestion = dependency.ask_if_val_in.includes(parentAnswer) ||
                                        dependency.ask_if_val_in.includes('*');
                    }

                    if (shouldShowQuestion) break;
                }

                if (shouldShowQuestion) break;
                nextIndex++;
            }

            // If we found a valid next question, go to it
            if (nextIndex < this.questions.length) {
                this.currentQuestionIndex = nextIndex;
                if (this.$route?.params?.questionId) {
                    this.$router.push({
                        ...this.$route,
                        params: { ...this.$route.params, questionId: this.questions[nextIndex].id }
                    });
                }
            } else {
                this.submitQuestionnaire();
            }
        },
        formatSubmissionData() {
            // Map medication answer to currentWeightloss value
            let currentWeightloss = "neither";
            if (this.answers['last_two_month_meds']) {
                if (this.answers['last_two_month_meds'].includes('Semaglutide')) {
                    currentWeightloss = "semaglutide";
                } else if (this.answers['last_two_month_meds'].includes('Tirzepatide')) {
                    currentWeightloss = "tirzepatide";
                }
            }

            // Map dose preference to weightlossPreference
            let weightlossPreference = "N/A";
            if (currentWeightloss !== "neither" && this.answers['next_dose_option']) {
                switch (this.answers['next_dose_option']) {
                    case "Decrease dose":
                        weightlossPreference = "decrease";
                        break;
                    case "Stay at the same dose or equivalent dose":
                        weightlossPreference = "same";
                        break;
                    case "Increase the dose if a higher one is available, or continue with my current dose if it's already at the maximum":
                        weightlossPreference = "increase";
                        break;
                    default:
                        weightlossPreference = "N/A";
                }
            }

            // Map current dose to standard format
            let currentDose = "N/A";
            if (currentWeightloss !== "neither") {
                const doseAnswer = this.answers['recent_dose_glp'];
                if (doseAnswer) {
                    // Map Semaglutide doses
                    const semaglutideDoseMap = {
                        "Semaglutide 0.25mg": "Weightloss1",
                        "Semaglutide 0.5mg": "Weightloss2",
                        "Semaglutide 1mg": "Weightloss3",
                        "Semaglutide 1.7mg": "Weightloss4",
                        "Semaglutide 2.4mg": "Weightloss5"
                    };

                    // Map Tirzepatide doses
                    const tirzepatideDoseMap = {
                        "Tirzepatide 2.5mg": "Weightloss1",
                        "Tirzepatide 5mg": "Weightloss2",
                        "Tirzepatide 7.5mg": "Weightloss3",
                        "Tirzepatide 10mg": "Weightloss4",
                        "Tirzepatide 12.5mg": "Weightloss4",
                        "Tirzepatide 15mg": "Weightloss5"
                    };

                    currentDose = currentWeightloss === "semaglutide" 
                        ? semaglutideDoseMap[doseAnswer] || "N/A"
                        : tirzepatideDoseMap[doseAnswer] || "N/A";
                }
            }

            // Initialize formObj with required fields
            let formObj = {
                consentsSigned: true,
                sex: this.answers['gender'],
                selfReportedMeds: this.answers['current_medications'] || 'N/A',
                allergies: this.answers['allergies'] || 'None',
                medicalConditions: this.answers['current_medical_conditions'] || 'N/A',
                currentWeightloss,
                weightlossPreference,
                currentDose
            };

            // Initialize images object
            const images = {};
            
            // Process all questions
            this.questions.forEach((question, index) => {
                const questionNumber = index + 1;
                
                // Handle image type questions
                if (question.question_type === 'image_upload') {
                    if (this.answers[question.question]) {
                        images[question.question] = this.answers[question.question];
                    }
                    return; // Skip adding image questions to Q&A pairs
                }
                
                // Skip questions that weren't shown due to dependencies
                if (!this.answers[question.question] && 
                    !this.checkboxAnswers[question.question]) {
                    return;
                }

                // Get the answer based on question type
                let answer = question.question_type === 'checkbox' 
                    ? (this.checkboxAnswers[question.question] || []).join('; ')
                    : (this.answers[question.question] || 'N/A');

                // Special handling for height/weight question
                if (question.question_type === 'height_weight') {
                    
                    if (question.label.includes('height')) {
                        answer = `${this.height.feet}'${this.height.inches}"`;
                    } else if (question.label.includes('weight')) {
                        answer = `${this.weight} lbs`;
                    }
                }

                // Format the question with label and possible answers
                const questionKey = `Q${questionNumber}`;
                const answerKey = `A${questionNumber}`;
                
                let questionText = question.label;
                if (question.options_array && question.options_array.length > 0) {
                    questionText += ` POSSIBLE ANSWERS: ${question.options_array.join('; ')}`;
                }

                formObj[questionKey] = questionText;
                formObj[answerKey] = answer;
            });

            
            // Return both formObj and images as separate properties
            return {
                formObj: formObj,
                images: images
            };
        },
        async submitQuestionnaire() {
            this.submitting= true;
            this.errorOccurred= false;
            const submissionData = this.formatSubmissionData();
            try {
                const response = await this.$axios.post(`${this.baseUrl}/forms/assessment-form/ghk-cu-screening/${this.$route.params.id}`, submissionData);
                // Handle success
                console.log(response)
                this.$router.push('/home');
            } catch (error) {
                // Handle error
                this.errorOccurred= true;
                console.error('Error submitting questionnaire:', error);
                this.submitting= false;
            }
        },
        getPrefilledAnswer(questionId) {
            const question = this.questions.find(q => q.id === questionId);
            if (!question || !this.initialData) return null;

            // Match based on question properties
            const questionType = question.question_type;
            const questionText = question.label.toLowerCase();
            const questionKey = question.question.toLowerCase();

            switch (questionType) {
                case 'radio':
                    if (questionText.includes('gender')) {
                        return this.initialData.gender;
                    }
                    break;

                case 'height_weight':
                    if (questionText.includes('height')) {
                        return this.height;
                    }
                    if (questionText.includes('weight')) {
                        return this.weight;
                    }
                    break;
            }

            // Try to find a matching key in initialData
            return Object.entries(this.initialData).find(([key]) => 
                questionKey.includes(key.toLowerCase()))?.[1] || null;
        },
        initializeCheckboxAnswers() {
            this.questions.forEach(question => {
                if (question.question_type === 'checkbox') {
                    this.$set(this.checkboxAnswers, question.question, [])
                }
            })
        },
        scrolltoTop() {
            window.scrollTo(0, 0);
        },
        findFirstUnansweredQuestion() {
            let index = 0;
            while (index < this.questions.length) {
                const question = this.questions[index];
                
                // Skip this question if it's already been skipped
                if (this.skippedQuestions.includes(question.id)) {
                    index++;
                    continue;
                }

                // Check if we have a dependency that prevents showing this question
                const dependency = this.dependencies.find(d => d.question_id === question.id);
                if (dependency) {
                    const canShow = this.checkDependency(dependency);
                    if (!canShow) {
                        index++;
                        continue;
                    }
                }

                // If we don't have an answer for this question, this is our starting point
                if (!this.answers[question.question]) {
                    break;
                }

                index++;
            }
            this.currentQuestionIndex = index;
        },

        checkDependency(dependency) {
            const dependentOn = Array.isArray(dependency.dependent_on) 
                ? dependency.dependent_on 
                : [dependency.dependent_on];

            for (const parentId of dependentOn) {
                const parentQuestion = this.questions.find(q => q.id === parentId);
                if (!parentQuestion) continue;

                // Get parent answer based on question type
                const parentAnswer = parentQuestion.question_type === 'checkbox'
                    ? this.checkboxAnswers[parentQuestion.question]
                    : this.answers[parentQuestion.question];

                // If we don't have an answer for the parent question, dependency is not met
                if (!parentAnswer) return false;

                // Special handling for checkbox type questions
                if (parentQuestion.question_type === 'checkbox') {
                    const selectedValues = this.checkboxAnswers[parentQuestion.question] || [];
                    // Check if any of the selected values match the dependency values
                    return selectedValues.some(selected => dependency.ask_if_val_in.includes(selected));
                }

                // Regular handling for non-checkbox questions
                if (dependency.ask_if_val_in) {
                    if (dependency.ask_if_val_in.includes(parentAnswer) || 
                        dependency.ask_if_val_in.includes('*')) {
                        return true;
                    }
                }
            }
            return false;
        },
        findFirstQuestionIndex() {
            let index = 0;
            while (index < this.questions.length) {
                const question = this.questions[index];
                
                // If this question was marked as skipped, move to next
                if (this.skippedQuestions.includes(question.id)) {
                    index++;
                    continue;
                }

                // Check dependencies
                const dependency = this.dependencies.find(d => d.question_id === question.id);
                if (dependency) {
                    const shouldShow = this.checkDependency(dependency);
                    if (!shouldShow) {
                        index++;
                        continue;
                    }
                }

                // For height/weight question, check if both height and weight are set
                if (question.question_type === 'height_weight') {
                    if (this.height.feet && this.height.inches && this.weight) {
                        index++;
                        continue;
                    }
                } else if (this.answers[question.question]) {
                    // For other questions, check if they're answered
                    index++;
                    continue;
                }

                // Found the first unanswered question that should be shown
                break;
            }
            this.currentQuestionIndex = index;
        }
    },
    watch: {
        currentQuestionIndex() {
            this.scrolltoTop()
        }
    },
    created() {
        if (this.initialData) {
            // Handle gender
            if (this.initialData.gender) {
                this.answers['gender'] = this.initialData.gender;
                this.skippedQuestions.push('0');
            }

            // Handle height/weight combined
            if (this.initialData.height && this.initialData.weight) {
                // Parse height
                const heightParts = this.initialData.height.split("'");
                if (heightParts.length === 2) {
                    this.height.feet = heightParts[0];
                    this.height.inches = heightParts[1].replace('"', '');
                }

                // Parse weight
                this.weight = this.initialData.weight.toString().replace(' lbs', '');

                // Calculate BMI
                const heightInInches = (parseInt(this.height.feet) * 12) + parseInt(this.height.inches || 0);
                const bmiValue = ((parseInt(this.weight) * 703) / (heightInInches * heightInInches));
                
                // Set all height/weight related answers
                this.answers['height'] = this.height;
                this.answers['weight'] = this.weight;
                this.answers['bmi'] = bmiValue.toFixed(1);
                this.answers['height_weight'] = `Height : ${this.height.feet}' ${this.height.inches} . Weight : ${this.weight}. Your BMI is ${bmiValue.toFixed(1)}`;
                // Skip the height/weight question
                this.skippedQuestions.push('4');
            }

            console.log('Initialized answers:', this.answers);
            console.log('Skipped questions:', this.skippedQuestions);
        }

        // Initialize checkbox answers
        this.initializeCheckboxAnswers();
        
        // Find first question to show
        this.findFirstUnansweredQuestion();
    },
}
</script>

<style scoped>
.balugabtn {
    margin-top: -40px !important;
    padding-top: 15px !important;
}

.bmi-result {
    margin: 20px 0;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 4px;
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
}

.scroll-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: opacity 0.3s ease;
    z-index: 1;
}

.scroll-overlay[v-show="false"] {
    opacity: 0;
    pointer-events: none;
}

.questions-div {
        padding-top: 30px;
        padding-bottom: 50px;
        max-width: 100%;
        padding-left: 20px;
        padding-right: 20px;
}
.acceptbutton{
    background-color: var(--light-green) !important;
    border: none;
}
.rejectconbutton{
    background-color: transparent !important;
    height: 20px;
    border: none;
    text-align: center;
    justify-content: center;
}
.rejectconbutton .text-block-545{
    font-size: 12px !important;
}
</style>
